module.exports = __webpack_public_path__ + "static/media/cel_generic_port.a342a600.jpg";